import { THeadingTypes } from "../../../types/heading-types";

export type THeadingProps = {
  children: React.ReactNode;
  className?: string;
  semanticType?: THeadingTypes;
  visualType?: Exclude<THeadingTypes, "h6">;
  index?: number;
};

export const Heading = ({
  children,
  className,
  index,
  semanticType = "h2",
  visualType = semanticType !== "h6" ? semanticType : "h5",
}: THeadingProps) => {
  if (!children) {
    return null;
  }

  if (typeof index === "number" && index === 0) {
    return <h1 className={`${className} ${visualType}`}>{children}</h1>;
  }

  const HeadingType = semanticType;

  return <HeadingType className={[className, visualType ? visualType : ""].join(" ")}>{children}</HeadingType>;
};

export default Heading;
